var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexCon"},[_c('swiperCon'),_c('div',{staticClass:"book_con"},[_c('div',{staticClass:"banner"}),_c('carefullyChosen')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }